import { useContext } from 'react';

import { OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionStateContext } from './OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider';

import OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData from './OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData';

const useOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData = () => {
  const [omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState, setOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionState] = useContext(OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionStateContext);

  const getOrgUnitNonAthleteEntryCredentialsSelection = (omeMeetOrgUnitEntryId, filterObj) =>
    OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData.getOrgUnitNonAthleteEntryCredentialsSelectionData(omeMeetOrgUnitEntryId, JSON.stringify(filterObj), omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState, setOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionState);

  const postOrgUnitNonAthleteEntryCredentialsSelection = (omeMeetOrgUnitEntryId, orgUnitNonAthleteEntryArray, credentialTypeId) =>
    OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData.postOrgUnitNonAthleteEntryCredentialsSelectionData(omeMeetOrgUnitEntryId, orgUnitNonAthleteEntryArray, credentialTypeId, omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState, setOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionState);

  const clearOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionArrayData = () => {
    setOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionState({
      ...omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: [],
      message: ''
    });
  };

  return {
    omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState,
    setOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionState,
    getOrgUnitNonAthleteEntryCredentialsSelection,
    postOrgUnitNonAthleteEntryCredentialsSelection,
    clearOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionArrayData
  };
};

export default useOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData;